import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'

export const firebaseApp = initializeApp({
    apiKey: "AIzaSyA6dY7ofs6DXCMTi8-MGGjTPXpDDGHsrvM",
    authDomain: "mypets-incendios-patagonia.firebaseapp.com",
    projectId: "mypets-incendios-patagonia",
    storageBucket: "mypets-incendios-patagonia.firebasestorage.app",
    messagingSenderId: "20827797609",
    appId: "1:20827797609:web:a003c3b148ed1348200af8",
    measurementId: "G-XE66M64V83"
})

export const analytics = getAnalytics(firebaseApp)
export const db = getFirestore(firebaseApp)